import { ActionDispatchers } from '../action';
import {
    CONTAINER_CAPTCHA,
    CAPTCHA_IMAGE_ELEMENT,
    HEADER_AUDIO,
    HEADER_IMAGE,
    CAPTCHA_AUDIO_ELEMENT,
    INPUT_CAPTCHA_RESULT,
    CONTAINER_CAPTCHA_IMAGE,
    BUTTON_EVENT_CLICK,
} from '../constant';
import {
    CaptchaMediaType,
    IFormElements,
} from '../interface';
import { terminateContractForm } from './terminateContractForm.helper';

/**
 * Create an image/audio element with the captcha url as source
 * but check if it already exists first
 * as we want to be able to generate a new one on refresh button click
 * and only change the source value
 */
export const createCaptcha = (
    mediaType: CaptchaMediaType,
    url: string,
    captchaHash: string,
    actions: ActionDispatchers,
    formElements: IFormElements,
) => {
    const { sendBtn, playBtn, refreshBtn } = formElements;
    const captchaContainer = document.getElementById(CONTAINER_CAPTCHA) as HTMLDivElement;
    const captchaImageContainer = document.getElementById(CONTAINER_CAPTCHA_IMAGE) as HTMLDivElement;
    let captchaImage = document.getElementById(CAPTCHA_IMAGE_ELEMENT) as HTMLImageElement;
    let captchaAudio = document.getElementById(CAPTCHA_AUDIO_ELEMENT) as HTMLAudioElement;
    const captchaResultInput = document.getElementById(INPUT_CAPTCHA_RESULT) as HTMLInputElement;

    switch (mediaType) {
        case HEADER_IMAGE: {
            if (!captchaImage) {
                captchaImage = document.createElement('img');
                captchaImage.setAttribute('id', CAPTCHA_IMAGE_ELEMENT);
                captchaImageContainer.prepend(captchaImage);
            }

            captchaImage.src = url;
            break;
        }
        case HEADER_AUDIO: {
            if (!captchaAudio) {
                captchaAudio = document.createElement('audio');
                captchaAudio.setAttribute('id', CAPTCHA_AUDIO_ELEMENT);
                captchaContainer.prepend(captchaAudio);
            }

            captchaAudio.src = url;
            captchaAudio.play();
            const playBtnUpdatedProps = playBtn!.getProperties();

            playBtnUpdatedProps.business = {
                onClick: () => captchaAudio.play(),
            };
            playBtn!.update(playBtnUpdatedProps);
            captchaImage.style.display = 'none';
            break;
        }
    }
    // these updates are needed because this fucntion is called only if the url has changed
    // since a new captcha has is provided after every fetch we need to update the reference
    // inside the terminate contract api request

    const sendBtnUpdatedProps = sendBtn!.getProperties();
    sendBtnUpdatedProps.business = {
        onClick: function sendForm () {
            terminateContractForm(actions.terminateContract, captchaHash);
        },
    };
    sendBtn!.update(sendBtnUpdatedProps);

    // must be a regular function to take advantage of the this / event.currentTarget reference
    function listener (event: Event) {
        URL.revokeObjectURL(url);
        actions.getCaptcha(mediaType);
        captchaResultInput.value = '';
        event.currentTarget?.removeEventListener(BUTTON_EVENT_CLICK, listener);
    }

    const refreshBtnUpdatedProps = refreshBtn!.getProperties();
    refreshBtnUpdatedProps.business = {
        onClick: listener,
    };
    refreshBtn!.update(refreshBtnUpdatedProps);
};
